/** Подпись срока блокировки в выпадающем списке: 300 → «Через 5 минут». */
export function lockChoiceLabel(seconds: number): string {
  const minutes = Math.round(seconds / 60)
  if (minutes === 60) return 'Через 1 час'
  if (minutes === 1) return 'Через 1 минуту'
  return `Через ${minutes} минут`
}
